// extracted by mini-css-extract-plugin
module.exports = {"container":"course-text-block_container__hUGAG","title":"course-text-block_title__7I_sQ","wrap":"course-text-block_wrap__dRmPO","txt":"course-text-block_txt__8FlLK"};